export const words = {
  album_title: "Nazwa albumu",
  rename: "Zmień nazwę",
  no_images: "Pusty",
  albums: "Albumy",
  email: "e-mail",
  Email: "e-mail",
  password: "hasło",
  login: "Zaloguj się",
  pictures: "Zdjęcia",
  copy_link: "Skopiuj link",
  share_with_whatsapp: "przez WhatsApp",
  qrdownload: 'Qr-Code Download',
  flyerdownload: "Projekty kart z kodem QR",
  logout: "Wyloguj się",
  challenge: "Wyzwanie fotograficzne",
  preparation: "Przygotowanie",
  photos: "Zdjęcia",
  challenges: "Wyzwanie",
  diashow: "Pokaz slajdów na żywo",
  settings: "Ustawienia",
  invitation: "Zaproszenie",
  of: "z",
  comments: "Komentarze",
  liked: "Na przykład",
  answer: "Odpowiedzi",
  minutes: " minuty",
  hours: " Godziny",
  days: " Dni",
  yesterday: "Wczoraj",
  hide: "Ukryj",
  choose: "Wybierz",
  share: "Udostępnij",
  report: "Raport",
  delete: "Usuń",
  description: "Opis",
  enter: "Dołącz",
  install: "Zainstaluj",
  or: "lub",
  event: "wydarzenie",
  save: "Oszczędzaj",
  cancel: "Anuluj",
  continue: "Dalej",
  task: "Zadanie",
  take_photo: "Zrób zdjęcie",
  skip: "Pomiń",
  color: "Kolor",
  videos: "Filmy",
  video: "Wideo",
  eur: 'Euro',
  usd: "Dolar",
  packages: {
    free: "Darmowy",
    base: "Baza",
    upgrade_base_to_premium: 'Premium',
    upgrade_base_to_deluxe: 'Deluxe',
    premium: 'Premium',
    upgrade_premium_to_deluxe: 'Deluxe',
    deluxe: 'Deluxe'
  },
  1: "A",
  2: "Dwa",
  3: "Trzy",
  4: "Cztery",
  5: "Pięć",
  download: "Pobierz",
  are: "są",
  is: "jest",
  mass_download: "Masowe pobieranie",
  upgrade: "Aktualizacja",
  start_now: "Rozpocznij",
  live_diashow: "Pokaz slajdów na żywo",
  code: "Kod",
  selected: "Wybrane",
  chosen: "wybrany",
  all: "Wszystkie",
  picture: "Zdjęcie",
  language: "Język",
  languages: {
    de: "Niemiecki",
    en: "Angielski",
    fr: "Francuski",
    it: "Włoski",
    es: "Hiszpański"
  },
  close: "Zamknij",
  edit: "Edytuj",
  release: "Zwolnienie",
  check: "Sprawdź",
  Name: "Nazwa",
  area_of_work: "Przemysł",
  instagram_name: "Nazwa na Instagramie",
  send: "Wyślij",
  submit: "Potwierdź",
  visible: "Widoczny"
};